import { WebsiteDomainActivationStatus } from '../professional';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_WEBSITE_DOMAIN_ACTIVATION_STATUS = 'WEBSITE_DOMAIN_ACTIVATION_STATUS_';

export const WebsiteDomainActivationStatusTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_WEBSITE_DOMAIN_ACTIVATION_STATUS}${WebsiteDomainActivationStatus.NONE}`]: 'Non configuré',
    [`${TRANSLATE_KEY_WEBSITE_DOMAIN_ACTIVATION_STATUS}${WebsiteDomainActivationStatus.PAYMENT_PENDING}`]:
      'Paiement en attente',
    [`${TRANSLATE_KEY_WEBSITE_DOMAIN_ACTIVATION_STATUS}${WebsiteDomainActivationStatus.DNS_ORDERED}`]:
      'Commande en cours',
    [`${TRANSLATE_KEY_WEBSITE_DOMAIN_ACTIVATION_STATUS}${WebsiteDomainActivationStatus.DNS_RESERVED}`]:
      'Domaine réservé',
    [`${TRANSLATE_KEY_WEBSITE_DOMAIN_ACTIVATION_STATUS}${WebsiteDomainActivationStatus.DNS_CONFIGURED}`]:
      'DNS configuré',
    [`${TRANSLATE_KEY_WEBSITE_DOMAIN_ACTIVATION_STATUS}${WebsiteDomainActivationStatus.PROPELSIA_CONFIGURED}`]:
      'DNS propagé',
    [`${TRANSLATE_KEY_WEBSITE_DOMAIN_ACTIVATION_STATUS}${WebsiteDomainActivationStatus.K8S_CONFIGURED}`]:
      'Mise en ligne',
    [`${TRANSLATE_KEY_WEBSITE_DOMAIN_ACTIVATION_STATUS}${WebsiteDomainActivationStatus.HTTPS_CONFIGURED}`]: 'En ligne',
    [`${TRANSLATE_KEY_WEBSITE_DOMAIN_ACTIVATION_STATUS}${WebsiteDomainActivationStatus.TRANSFER_PENDING}`]:
      'Transfert en attente',
    [`${TRANSLATE_KEY_WEBSITE_DOMAIN_ACTIVATION_STATUS}${WebsiteDomainActivationStatus.TRANSFER_IN_PROGRESS}`]:
      'Transfert en cours',
    [`${TRANSLATE_KEY_WEBSITE_DOMAIN_ACTIVATION_STATUS}${WebsiteDomainActivationStatus.TRANSFER_MANUAL_ACTION}`]:
      'Action requise',
    [`${TRANSLATE_KEY_WEBSITE_DOMAIN_ACTIVATION_STATUS}${WebsiteDomainActivationStatus.TRANSFER_FAILED}`]:
      'Transfert échoué',
    [`${TRANSLATE_KEY_WEBSITE_DOMAIN_ACTIVATION_STATUS}${WebsiteDomainActivationStatus.DNS_ORDER_FAILED}`]:
      'Échec de la commande',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(
  WebsiteDomainActivationStatus,
  WebsiteDomainActivationStatusTranslation,
  TRANSLATE_KEY_WEBSITE_DOMAIN_ACTIVATION_STATUS,
  true,
);
